import { useDispatch, useSelector } from "react-redux";
import {
  closeModal,
  openModal,
  setSelectedSize,
} from "../../features/fontSizeAdjustor/FontSizeAdjustorSlice";
import { FONT_SIZES } from "../../utils/fontSizeSelection";

export function useFontSizeAdjustor() {
  const { isOpen, selectedSize } = useSelector(
    (state) => state.fontSizeAdjustor,
  );
  const dispatch = useDispatch();

  const handleChange = (event) => {
    const newSize = FONT_SIZES[Number(event.target.value)];
    dispatch(setSelectedSize(newSize));
  };

  return {
    isOpen,
    selectedSize,
    openModal: () => dispatch(openModal()),
    closeModal: () => dispatch(closeModal()),
    setSelectedSize: (event) => handleChange(event),
  };
}
